<template>
  <div class="padding" :class="{'disable-ske': !loading}">
    <ComposableTable
      v-if="showTable"

      id="orders-composable-table"
      :disableIsLoadingTalueResult="true"
      :data="ordersData"
      :columns="columns"
      :variables="variables"
      :loading="loading"
      :on-row-click="viewOrder"

      @update-column-order="updateColumnOrder"
      :sort="sort"
      :order="order"
      @set-sort="setSort"
      @set-order="setOrder"
    >
      <template #cell-site="{ item, value }">
        <router-link :to="`/admin/order/${item.uid}`">
          {{ item.site }}
        </router-link>
      </template>

      <template #cell-qty="{ item }">
        <span class="qty-circle">{{ item.qty }}</span>
      </template>
    </ComposableTable>

    <div class="pagination d-flex justify-content-center" v-if="!loading">
      <Pagination :max="max" :value="page" @input="(p) => (page = p)" />
    </div>
  </div>
</template>

<script>

import FormInput from "@/components/Inputs/FormInput.vue"
import FormSelect from "@/components/Inputs/FormSelect.vue"
import FormDatePicker from "@/components/Inputs/FormDatePicker.vue"
import ComposableTable from "../../ComposableTable/ComposableTable.vue"
import Pagination from "@/layout/Pagination.vue"

import simpleReodering from "@/components/Product/ComposableTable/simple-reodering"

export default {
  mixins: [
    simpleReodering({
      dataSource: "ordersData",
      key: "product-orders",
      columns: [
        "Bestelnummer",
        "Website",
        "Besteldatum",
        "Bestelbedrag",
        "Klant",
        "Status",
        "Aantal producten",
      ],
      variables: [
        "orderNumber",
        "site",
        "orderDate",
        "orderAmount",
        "customer",
        "state",
        "qty"
      ],
    }),
  ],
  components: {
    FormSelect,
    FormDatePicker,
    FormInput,
    ComposableTable,
    Pagination,
  },
  props: {
    isActive: Boolean,
    productId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showTable: true,

      ordersData: null,
      page: 1,
      total: 1,
      statusOptions: [
        {
          str: "All",
          value: null,
        },
        {
          str: "Not Sent",
          value: "NOT_SENT",
        },
        {
          str: "Sent to PostNL",
          value: "SENT_TO_POSTNL",
        },
        {
          str: "Shipped",
          value: "SHIPPED",
        },
        {
          str: "Canceled",
          value: "CANCELED",
        },
      ],
      selectedStatus: null,
      dateRange: [],
      date: null,
      loading: false,
    }
  },

  computed: {
    max() {
      return Math.ceil(this.total / 10);
    },
    sorting() {
      return this.sort + this.order
    },
  },

  watch: {
    sorting() {
      this.fetchOrders()
    },
    isActive() {
      this.showTable = false
      this.$nextTick(() => this.showTable = true)
    },
    selectedStatus() {
      this.fetchOrders();
    },
    dateRange(orderDate) {
      if (orderDate.length > 1) this.fetchOrders();
    },
    page() {
      this.fetchOrders();
    }
  },

  mounted() {
    this.fetchOrders();
  },

  methods: {
    async fetchOrders() {
      if (this.sort && !this.order) return;
      this.loading = true;

      await this.axios
        .get(`/api/products/${this.productId}/orders`, {
          params: {
            page: this.page,
            page_size: 30,

            sort: this.sort,
            sort_type: this.order,
          },
        })
        .then(({ data: { results, total } }) => {
          this.ordersData = results.map(item => ({ ...item, qty: item.orders[0].qty }));
          this.total = total;
        })
        .catch((error) => console.log(error))
        .finally(() => (this.loading = false));
    },

    handleDate(date) {
      this.dateRange = date;
    },

    // function do make query params
    makeQueryParams() {
      const params = {};

      if (this.selectedStatus) {
        params.status = this.selectedStatus;
      }

      if (this.dateRange) {
        params.orderDate = this.dateRange;
      }

      return params;
    },

    viewOrder(item) {
      this.$router.push(`/admin/order/${item.uid}`).catch(()=>{})
    },
  },
};
</script>

<style scoped>

.form-select {
  width: 150px !important;
}

</style>
